import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout from "./Layout";
import AdsAssistantChat from "./AdsAssistantChat";
import { Form, Spinner } from "react-bootstrap";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

const SponsoredBrands = () => {
  const [uploading, setUploading] = useState(false);
  const [uploadMsg, setUploadMsg] = useState(null);
  const [brandEntityId, setBrandEntityId] = useState("");
  const [isManualBrandEntry, setIsManualBrandEntry] = useState(false);
  const [availableBrands, setAvailableBrands] = useState([]);
  const [loadingBrands, setLoadingBrands] = useState(false);

  const getProfileId = () =>
    localStorage.getItem("selectedAccountValue") || null;

  useEffect(() => {
    fetchBrands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchBrands = async () => {
    const profileId = getProfileId();
    if (profileId) {
      setLoadingBrands(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/sb-single-keyword/brandsprofileId=${profileId}`,
        );
        if (response.ok) {
          const data = await response.json();
          if (data.success && data.brands) {
            setAvailableBrands(data.brands);
            if (data.brands.length > 0 && !brandEntityId) {
              setBrandEntityId(data.brands[0].brandEntityId);
            }
          }
        }
      } catch (err) {
        console.error("Error fetching brands:", err);
      } finally {
        setLoadingBrands(false);
      }
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("logo", file);

    // Intentar obtener profileId de localStorage
    try {
      const storedProfile = localStorage.getItem("selectedProfile") ? JSON.parse(localStorage.getItem("selectedProfile")) : null;
      if (storedProfile.profileId) {
        formData.append("profileId", storedProfile.profileId);
      }
    } catch (e) {
      console.warn("Error parsing selectedProfile", e);
    }

    setUploading(true);
    setUploadMsg(null);

    try {
      // URL del backend (asumiendo puerto 3000)
      const apiUrl =
        process.env.REACT_APP_API_URL || "http://localhost:3000/api";
      await axios.post(`${apiUrl}/upload/logo`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setUploadMsg({
        type: "success",
        text: "Logo uploaded. You can now create your campaign in chat.",
      });
    } catch (error) {
      console.error("Error uploading logo:", error);
      setUploadMsg({ type: "danger", text: "❌ Error uploading logo." });
    } finally {
      setUploading(false);
    }
  };

  return (
    <Layout>
      <div className="ads-page-container">
        <div
          className="ads-page-header"
          style={{
            marginBottom: "1rem",
            backgroundColor: "#212529",
            padding: "1rem",
            borderRadius: "8px",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h2 className="text-white">
                <i className="bi bi-award"></i> Sponsored Brands Campaigns
              </h2>
              <p className="text-white-50 mb-0">
                Create Sponsored Brands campaigns with product collections
              </p>
            </div>

            <div className="d-flex align-items-center gap-2">
              {uploadMsg && (
                <span className={`text-${uploadMsg.type === "success" ? "info" : "warning"} me-2`}
                  style={{ fontSize: "0.9rem", fontWeight: "500" }}
                >
                  {uploadMsg.text}
                </span>
              )}
              <Form.Label
                htmlFor="logo-upload"
                className="btn btn-light m-0 d-flex align-items-center gap-2" style={{ cursor : "pointer", fontWeight: "bold" }}
              >
                {uploading ? (
                  <Spinner size="sm" animation="border" />
                ) : (
                  <i className="bi bi-cloud-upload"></i>
                )}
                Upload Logo
              </Form.Label>
              <Form.Control
                type="file"
                id="logo-upload"
                accept="image/*"
                onChange={handleFileUpload}
                style={{ display: "none" }}
              />
            </div>
          </div>

          {/* Brand Entity ID Selector */}
          <div
            className="mb-3"
            style={{
              backgroundColor: "#1a1d20",
              padding: "1rem",
              borderRadius: "8px",
            }}
          >
            <Form.Group>
              <Form.Label className="text-white mb-2 fw-bold">
                <i className="bi bi-tag me-2"></i>Brand Entity ID{" "}
                {!brandEntityId && (
                  <span className="text-danger">(Optional)</span>
                )}
              </Form.Label>
              <Form.Select
                className="form-select-dark"
                style={{
                  backgroundColor: "#2d3238",
                  color: "white",
                  border: "1px solid #495057",
                }}
                value={isManualBrandEntry ? "MANUAL" : brandEntityId}
                onChange={(e) => {
                  if (e.target.value === "MANUAL") {
                    setIsManualBrandEntry(true);
                    setBrandEntityId("");
                  } else {
                    setIsManualBrandEntry(false);
                    setBrandEntityId(e.target.value);
                  }
                }}
                disabled={loadingBrands}
              >
                <option value="">Select a Brand Entity ID...</option>
                {availableBrands.map((b, i) => (
                  <option key={i} value={b.brandEntityId}>
                    {b.brandEntityId} ({b.brandRegistryName || "Unknown"})
                  </option>
                ))}
                <option value="MANUAL">✐ Enter manually...</option>
              </Form.Select>
              {isManualBrandEntry && (
                <Form.Control
                  type="text"
                  className="mt-2"
                  style={{
                    backgroundColor: "#2d3238",
                    color: "white",
                    border: "1px solid #495057",
                  }}
                  placeholder="ENTITY..."
                  value={brandEntityId}
                  onChange={(e) => setBrandEntityId(e.target.value)}
                />
              )}
              {loadingBrands && (
                <small className="text-muted d-block mt-1">
                  <Spinner size="sm" animation="border" className="me-1" />
                  Loading brands...
                </small>
              )}
            </Form.Group>
          </div>
        </div>
        <AdsAssistantChat
          context="sponsored-brands"
          brandEntityId={brandEntityId}
        />
      </div>
    </Layout>
  );
};

export default SponsoredBrands;


